export const emailAddress = 'yjy197@outlook.com';
export const githubUrl = 'https://github.com/timyao21';
export const youtubeUrl = 'https://www.youtube.com/channel/UC9kCc8BtgMi9NnovEoh5PzQ';
export const insUrl = 'https://www.instagram.com/yjytimmm_21?igsh=cmh2MjlxcTNuMmY0&utm_source=qr';
export const insPhotoUrl = 'https://www.instagram.com/yjytim.jpg?igsh=cGZnZnBpZGIwY2xl&utm_source=qr';
export const bilibiliUrl = 'https://space.bilibili.com/626701417?spm_id_from=333.1007.0.0';
export const linkedInUrl = 'https://www.linkedin.com/in/junyuyao-tim/';
export const tandonCSSAUrl = "https://nyutandoncssa.com/#/";
